/**
 * Google Calendar Integration Enums
 */

/**
 * Calendar Event Processing Status
 * Tracks the processing state of a raw calendar event synced from Google.
 * - PENDING: newly synced, not yet processed
 * - PROCESSED: successfully matched to an account and Activity created
 * - REVIEW: no account match found (re-checked by nightly job when new accounts are added)
 * - FAILED: processing encountered an error
 * - UPDATED: event was updated in Google Calendar, needs re-processing
 */
export enum CalendarEventStatus {
  PENDING = "PENDING",
  PROCESSED = "PROCESSED",
  REVIEW = "REVIEW",
  FAILED = "FAILED",
  UPDATED = "UPDATED",
}
